<template lang="pug">
div
  div.header
    img( src="@/assets/arrow-left.svg" @click="backPage" )
    span.ml-2.text-20-b {{ returnTitle }}
  div.mt-3.adding-container(v-if="selectedGoal && formLoaded")
    span.text-18 На что ты хочешь копить?
    castom-text-field( v-model="selectedGoal.title" readonly placeholder="Например: велосипед, ноутбук..." details="Выберите из предложенных иконок." )
    choose-icon.mt-3( :goalTitle="selectedGoal.title" @selectGoal="selectGoal" )
    span.mt-3.text-18 Сколько нужно накопить?
    castom-text-field( v-model="selectedGoal.full_amount" type="money" placeholder="Введите сумму в рублях " details="Выбери сумму, которую реально накопить!" )
    span.mt-3.text-18 Когда хочешь достигнуть цели?
    choose-deadline.mt-1( @chooseDeadline="chooseDeadline")
    span.mt-3.text-18 Мотивационная речь
    motivational-speech( :audioUrl="speechUrl" @loadSpeech='loadSpeech' @deleteAudio='deleteAudio')
    div.visualization
      span.mt-3.text-18 Визуализация цели (QR)
      img.delete-img( v-if="fileUrl" src="@/assets/goalIcon/delete-photo.svg" @click="deletePhoto")
    goal-visualization.mt-1( v-model="selectedGoal.full_amount" :imgUrl="fileUrl" :deadline="selectedGoal.completed_date" @loadPhoto="loadPhoto" )
    div.button-container.mt-3
      button.button.cancel.text-16-b( @click="backPage" ) Отмена
      button.button.create-goal.text-16-b( @click="createGoal" ) {{ returnButtonText }}


</template>

<script>
import ChooseIcon from './ChooseIcon.vue';
import ChooseDeadline from './ChooseDeadline.vue';
import MotivationalSpeech from './MotivationalSpeech.vue';
import GoalVisualization from './GoalVisualization.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
export default {
  name: 'AddGoal',

  components: {
    ChooseIcon,
    ChooseDeadline,
    MotivationalSpeech,
    GoalVisualization
  },

  props: {
    goalUuid: {
      type: String,
      defauls: ''
    }
  },

  data() {
    return {
      fileUrl: null,
      speechUrl: null,
      formLoaded: false,
      formattedAmount: null
    };
  },

  mounted() {
    if(!this.goalUuid) this.getFormGoal().then(() => this.formLoaded = true) 
    else this.formLoaded = true
    if(this.selectedGoal && this.selectedGoal.file && this.selectedGoal.file != '') this.loadPhoto()
    if(this.selectedGoal && this.selectedGoal.audio && this.selectedGoal.audio != '') this.loadSpeech()
  },

  computed: {
    ...mapState('goals', ['selectedGoal']),

    returnTitle() {
      return this.goalUuid ? "Редактировать цель" : "Добавить цель"
    },

    returnButtonText() {
      return this.goalUuid ? "Сохранить цель" : "Создать цель"
    }
  },

  methods: {
    ...mapActions('goals', ['getFormGoal', 'addGoal', 'loadGoalPhoto', 'loadGoalSpeech', 'loadGoalList', 'deleteAttachment', 'deleteSpeech']),
    ...mapMutations('goals', ['setSelectedGoal']),

    deletePhoto() {
      let obj = {goalsUuid: this.selectedGoal.uuid, state: 1}
      this.deleteAttachment(obj).then(() => {
        this.fileUrl = null
      })
    },

    deleteAudio() {
      let obj = {goalsUuid: this.selectedGoal.uuid, state: 1}
      this.deleteSpeech(obj).then(() => {this.speechUrl = null})
    },

    backPage() {
      this.loadGoalList().then(() => {
        this.setSelectedGoal(null)
        this.$router.back()
      })
    },

    selectGoal(goal) {
      this.selectedGoal.title = goal.title
    },

    chooseDeadline(deadline){
      this.selectedGoal.completed_date = deadline
    },

    createGoal() {
      this.addGoal(this.selectedGoal).then(() => {
        this.setSelectedGoal(null)
        this.backPage()
      })
    },

    loadPhoto() {
      this.loadGoalPhoto(this.selectedGoal.uuid).then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        this.fileUrl = URL.createObjectURL(blob)
      })
    },

    loadSpeech(){
      this.loadGoalSpeech(this.selectedGoal.uuid).then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        this.speechUrl = URL.createObjectURL(blob)
      })
    }
  }
}
</script>
<style scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 42px;
  padding-left: 8px;
  box-shadow: 0px 0px 6px 0px #0000001F;
  background: #FFFFFF;
  padding: 12px 8px;
}
.header-icon {
  margin-left: auto;
}
.adding-container {
  display: flex;
  flex-direction: column;
  padding: 0 12px 12px 12px
}
.caption {
  color: #727272;
}
.button-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.button {
  border-radius: 8px;
  width: 164px;
  height: 42px;
  padding: 1px 10px 12px 10px 12px;
}
.cancel {
  background: #FFFFFF;
  border: 1px solid #5365E5
}
.create-goal {
  margin-left: auto;
  background: #5365E5;
  color: #FFFFFF;
}
.visualization {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.delete-img {
  margin-top: 13px;
  height: 25px;
}
</style>
